<template>
  <div>
    <div class="panel panel-default" v-if="infoResults.length">
      <div class="row summary-panel k-feedback-test-block">
        <h4 class="evaluation-title feedback-panel-title">
          <i class="fas fa-code" aria-hidden="true"></i> Information
        </h4>
      </div>
      <ul class="info-results">
        <li class="single-result" v-for="(entry, index) in infoResults" :key="index">
          <h5 class="report-title">{{entry.test_description}}</h5>
          <pre class="result-pre">{{entry.returned}}</pre>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.report-title {
  font-size: larger;
}

.info-results {
  display: block;
  width: 100%;
  padding: 0 15px 15px;
  margin: 0;
  list-style: none;
}

h4.evaluation-title {
  padding: 15px;
  width: 100%;
}

.panel-default {
  padding: 10px;
}

</style>

<script>
export default {
  props: {
    infoResults: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
